import { Injectable, EventEmitter } from "@angular/core";

import { Print } from "./classes/print";
import { PrintParamsData, PrintConfig } from "./print.interface";

import { DialogService } from "../dialog/index";

@Injectable()
export class PrintService {
  constructor(private _dialogService: DialogService) {}

  public onPrint: EventEmitter<Print> = new EventEmitter();
  public onPrintPrepare: EventEmitter<Print> = new EventEmitter();
  public printInstance: Print;

  private _default_config: PrintConfig = {
    async: false
  };

  public print(
    component: any,
    params?: PrintParamsData,
    config: PrintConfig = {}
  ): Print {
    config = Object.assign({}, this._default_config, config);

    this.printInstance = new Print(
      this,
      this._dialogService,
      {
        component: component,
        params: params
      },
      config
    );

    this.onPrintPrepare.emit(this.printInstance);

    if (!config.async) {
      setTimeout(() => this.printInstance.print(), 300);
    }

    return this.printInstance;
  }
}
